import { render, staticRenderFns } from "./forkLiftTypeManage.vue?vue&type=template&id=7e63ab74"
import script from "./forkLiftTypeManage.vue?vue&type=script&lang=js"
export * from "./forkLiftTypeManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e63ab74')) {
      api.createRecord('7e63ab74', component.options)
    } else {
      api.reload('7e63ab74', component.options)
    }
    module.hot.accept("./forkLiftTypeManage.vue?vue&type=template&id=7e63ab74", function () {
      api.rerender('7e63ab74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/heq/forkLiftTypeManage.vue"
export default component.exports